import { combineReducers } from 'redux'
import globalMessagingReducer from 'utils/reducers/globalMessaging'
import costControlConfigReducer from './costControlConfig'
import modalsReducer from './modals'
import spotBiddingConfigReducer from './spotBiddingConfig'
import spotBiddingConfigListReducer from './spotBiddingConfigList'

const reducers = combineReducers({
  globalMessaging: globalMessagingReducer,
  spotBiddingConfig: spotBiddingConfigReducer,
  spotBiddingConfigList: spotBiddingConfigListReducer,
  costControlConfig: costControlConfigReducer,
  modals: modalsReducer,
})

export default reducers
